<div class="folder-structure-builder">
  <div class="folder-structure-builder__header">
    <h3>{{ 'GNR_FOLDER_STRUCTURE' | translate }}</h3>
    @if (!readonly) {
      <div class="folder-structure-builder__header-actions">
        <button
          mat-icon-button
          qtDisableAfterClick
          (click)="addRootFolder()"
          [matTooltip]="'GNR_ADD_ROOT_FOLDER' | translate">
          <mat-icon>create_new_folder</mat-icon>
        </button>
        <button
          mat-icon-button
          qtDisableAfterClick
          (click)="addRootDocumentPlaceholder()"
          [matTooltip]="'GNR_ADD_ROOT_UPLOAD_REQUEST' | translate">
          <mat-icon>new_window</mat-icon>
        </button>
      </div>
    }
  </div>

  <div class="folder-structure-builder__tree" #folderTreeContainer>
    @if (visibleNodes().length === 0) {
      <div class="folder-structure-builder__empty-state">
        <div class="empty-state-content">
          <mat-icon class="empty-state-icon">folder_open</mat-icon>
          <p class="empty-state-description">
            {{ 'GNR_NO_FOLDERS_DESCRIPTION' | translate }}
          </p>
          @if (!readonly) {
            <div class="empty-state-buttons">
              <button
                mat-button
                color="primary"
                qtDisableAfterClick
                (click)="addRootFolder()"
                class="empty-state-button toolbar-action-btn">
                <mat-icon>create_new_folder</mat-icon>
                {{ 'GNR_ADD_ROOT_FOLDER' | translate }}
              </button>
              <button
                mat-button
                color="primary"
                qtDisableAfterClick
                (click)="addRootDocumentPlaceholder()"
                class="empty-state-button toolbar-action-btn">
                <mat-icon>new_window</mat-icon>
                {{ 'GNR_ADD_ROOT_UPLOAD_REQUEST' | translate }}
              </button>
            </div>
          }
        </div>
      </div>
    } @else {
      <div
        class="folder-structure-builder__list"
        cdkDropList
        [cdkDropListData]="folderNodes"
        id="main-list"
        [cdkDropListConnectedTo]="dropTargetIds"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListDisabled]="readonly">
        @for (node of visibleNodes(); track node.id) {
          <div
            class="folder-node"
            [class.not-draggable]="readonly"
            [attr.data-node-id]="node.id"
            cdkDrag
            [cdkDragData]="node"
            [cdkDragPreviewContainer]="'parent'"
            [cdkDragDisabled]="readonly"
            (cdkDragStarted)="onDragStarted($event)"
            (cdkDragEnded)="onDragEnded($event)">
            <div
              class="folder-node__content"
              [class.invalid-drop-target]="
                currentDraggedNode && !isValidDropTarget(node.id)
              "
              cdkDragHandle
              cdkDropList
              [cdkDropListData]="[]"
              [id]="node.id"
              [cdkDropListConnectedTo]="dropTargetIds"
              [cdkDropListDisabled]="readonly"
              (cdkDropListDropped)="drop($event)">
              <div
                class="folder-node__indent"
                [style.width.px]="(node.level || 0) * 20"></div>

              <button
                mat-icon-button
                class="folder-node__expand-toggle"
                [disabled]="!node.hasChildren || isDocumentPlaceholder(node)"
                (click)="toggleExpanded(node); $event.stopPropagation()"
                [matTooltip]="
                  node.hasChildren && !isDocumentPlaceholder(node)
                    ? node.isExpanded
                      ? ('GNR_CLICK_COLLAPSE' | translate)
                      : ('GNR_CLICK_EXPAND' | translate)
                    : ''
                ">
                <mat-icon>{{ getExpandIcon(node) }}</mat-icon>
              </button>

              <div class="folder-node__icon">
                <mat-icon [class.file-type-placeholder]="node.tp === '1'">{{
                  getFolderIcon(node)
                }}</mat-icon>
              </div>

              @if (!node.isEditing) {
                <div class="folder-node__name-container">
                  <span
                    class="folder-node__name"
                    [matTooltip]="node.name.length > 100 ? node.name : ''"
                    [matTooltipShowDelay]="500"
                    >{{ node.name }}</span
                  >
                  <span class="folder-node__level"
                    >({{ 'GNR_LEVEL' | translate }} {{ node.level || 0 }})</span
                  >
                  @if (!readonly) {
                    <button
                      mat-icon-button
                      (click)="startEdit(node); $event.stopPropagation()"
                      [matTooltip]="'CMD_CHANGE_NAME' | translate"
                      class="folder-node__action-button folder-node__edit-button">
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                </div>
              }

              @if (node.isEditing) {
                <input
                  type="text"
                  class="folder-node__input"
                  [attr.data-folder-id]="node.id"
                  [(ngModel)]="node.name"
                  (blur)="finishEdit(node)"
                  (keyup.enter)="finishEdit(node)"
                  (keyup.escape)="finishEdit(node)"
                  (click)="$event.stopPropagation()"
                  maxlength="100"
                  matInput />
              }

              @if (!readonly) {
                <div class="folder-node__actions">
                  @if (!isDocumentPlaceholder(node)) {
                    <button
                      mat-icon-button
                      qtDisableAfterClick
                      (click)="addSubFolder(node); $event.stopPropagation()"
                      [disabled]="!canAddChildren(node)"
                      [matTooltip]="
                        isAtMaxLevel(node)
                          ? ('GNR_MAXIMUM_FOLDER_DEPTH_REACHED' | translate) +
                            ' (' +
                            ('GNR_LEVEL' | translate) +
                            ' ' +
                            MAX_FOLDER_LEVEL +
                            ')'
                          : ('GNR_ADD_FOLDER' | translate)
                      "
                      class="folder-node__action-button">
                      <mat-icon>create_new_folder</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      qtDisableAfterClick
                      (click)="
                        addDocumentPlaceholder(node); $event.stopPropagation()
                      "
                      [disabled]="!canAddChildren(node)"
                      [matTooltip]="
                        isAtMaxLevel(node)
                          ? ('GNR_MAXIMUM_FOLDER_DEPTH_REACHED' | translate) +
                            ' (' +
                            ('GNR_LEVEL' | translate) +
                            ' ' +
                            MAX_FOLDER_LEVEL +
                            ')'
                          : ('GNR_ADD_UPLOAD_REQUEST' | translate)
                      "
                      class="folder-node__action-button">
                      <mat-icon>new_window</mat-icon>
                    </button>
                  }
                  <button
                    mat-icon-button
                    (click)="deleteFolder(node); $event.stopPropagation()"
                    [matTooltip]="'GNR_DEL' | translate"
                    class="folder-node__action-button folder-node__delete-button">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>

            <div *cdkDragPreview class="folder-node__preview">
              <div
                class="folder-node__preview-indent"
                [style.width.px]="(node.level || 0) * 20"></div>

              <button
                mat-icon-button
                class="folder-node__expand-toggle"
                disabled>
                <mat-icon>{{ getExpandIcon(node) }}</mat-icon>
              </button>

              <div class="folder-node__icon">
                <mat-icon>{{ getFolderIcon(node) }}</mat-icon>
              </div>

              <div class="folder-node__name-container">
                <span class="folder-node__name">{{ node.name }}</span>
                <span class="folder-node__level"
                  >({{ 'GNR_LEVEL' | translate }} {{ node.level || 0 }})</span
                >
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
